import { searchableComputedProperty, SB } from '@play-co/replicant';
import { State } from '../State';

export const duoProperties = {
  /** If the user has a pending debut */
  pendingDebut: searchableComputedProperty(
    SB.boolean(),
    ({ duo }: State) => !!duo.debut,
  ),
};
